import React from 'react';
import styled from 'styled-components';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { Typography } from 'src/typography';
import SvgPinIcon from 'src/assets/pin-icon';
import { CenteredColumn, StepPanel, StepFooter, StepHeader, StepButton } from '../shared-components';
import { GoodCannaIcon } from './good-canna-icon';

type GetStartedStepProps = {
  onNext: () => void;
};

export const GetStartedStep = ({ onNext }: GetStartedStepProps): JSX.Element | null => {
  const { dispensary } = useDispensary();

  return (
    <>
      <StepHeader showBackButton={false} />
      <StepPanel>
        <CenteredColumn>
          <GoodCannaIcon width={48} height={48} />
          <Typography.Heading tag='h2' size='medium'>
            Apply for your free medical certification with GoodCannaNow
          </Typography.Heading>
          <P size='medium'>We need additional personal & medical information.</P>
        </CenteredColumn>
      </StepPanel>

      <StepFooter>
        <P size='medium'>Certification will be shared with</P>
        <Location>
          <SvgPinIcon height={20} width={20} />
          <Typography.Body size='large' weight='bold'>
            {dispensary?.name}
          </Typography.Body>
        </Location>
        <StepButton onClick={() => onNext()} mt='16px'>
          Get Started
        </StepButton>

        <P size='medium' weight='bold'>
          <a href='https://app.goodcannanow.com/goodcannanow/'>Choose another dispensary</a>
        </P>
      </StepFooter>
    </>
  );
};

const P = styled(Typography.Body)`
  color: ${({ theme }) => theme.colors.grey[45]};
`;

const Location = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spaces[2]};
`;
